export enum RouteName {
	mainPage = 'mainPage',
	weather = 'weather',
	map = 'map',
	notFound = 'notFound',
	redirect = 'redirect',
}
